export default __webpack_public_path__ + "static/media/shantell-sans-v9-latin-600.49569092.woff2";